










import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import PropertySelector from "@/components/PropertySelector.vue";

@Component({
  components: {
    PropertySelector
  }
})
export default class Breadcrumb extends Vue {
  @Prop({default: () => [], required: true}) public list: any[];

  public isLast(index) {
    return index === this.list.length - 1;
  }

  public showName(item) {
    if (item.meta && item.meta.label) {
      item = item.meta && item.meta.label;
    }
    if (item.name) {
      item = item.name;
    }
    return item;
  }
}
